#import "src/allocation/graphql/fragments/allocationProjectFragment.graphql"
#import "src/fragments/workspace.graphql"
#import "src/fragments/userPersonFragment.graphql"
#import "src/queries/fragments/personManagersTagsFragment.graphql"

query getContext($isRestricted: Boolean!) {
  allocationProject: getAllocationProject @skip(if: $isRestricted) {
    ...AllocationProjectFragment
  }
  oldestPersonIndexDate: getOldestPersonIndexDate @skip(if: $isRestricted)
  version: getVersion
  maintenanceMode: getMaintenanceMode
  userPerson: getPersonForUser {
    ...UserPersonFragment
    ...PersonManagersTagsFragment
  }
  importDate: getLatestImportDate @skip(if: $isRestricted)
}

query getActiveWorkspace {
  activeWorkspace: getActiveWorkspace {
    ...FullWorkspaceFragment
  }
}

query getWorkspace($id: ID!, $includeReportingInfraProvisioned: Boolean!) {
  workspace: getWorkspace(id: $id) {
    ...FullWorkspaceFragment
  }
  isReportingInfraProvisioned: getReportingInfraProvisioned(workspaceId: $id)
    @include(if: $includeReportingInfraProvisioned)
}

query getReportingInfraProvisioned($workspaceId: ID!) {
  isReportingInfraProvisioned: getReportingInfraProvisioned(
    workspaceId: $workspaceId
  )
}

query getWorkspaces {
  workspaces: getWorkspaces {
    ...PartialWorkspaceFragment
  }
}

query getReportingResourceCreationStatus($workspaceId: ID!) {
  status: getReportingResourceCreationStatus(workspaceId: $workspaceId)
}
